<template>
  <div class="ShareTab">

    <share-items class="ShareTab-items" />

  </div>
</template>

<script>
export default {
  name: 'ShareTab'
}
</script>

<style>
@import 'properties';

.ShareTab {
  padding: 0 0 var(--unit);
  background-color: var(--c-blue);
  border-radius: var(--radius);

  @media (min-width: 600px) {
    padding: var(--unit) 0 0;
  }
}

.ShareTab-items {
  padding: var(--unit-075) 0 var(--unit-05);

  @media (min-width: 600px) {
    padding: var(--unit) 0 var(--unit-05);
  }
}

.ShareTab-items > * {
  display: flex;
  justify-content: center;
}

.ShareTab-items * + * {
  margin-top: var(--unit-05);
}

.ShareTab-items .ShareItem-icon {
  width: 42px !important;
  height: 42px !important;
}
</style>



// WEBPACK FOOTER //
// ShareTab.vue?34cb2a92